import React from 'react'
import { Aboutus } from '../component/Aboutus'
import { Contact } from '../component/Contact'
import { Home } from '../component/Home'
import { Projects } from '../component/Projects'
import { Services } from '../component/Services'
import { Skill } from '../component/Skill'
import { Footer } from '../layout/Footer'
import { Navigationbar } from '../layout/Navigationbar'

export const Homepage = () => {
  return (
    <div>
        <Navigationbar/>
        <Home/>
        <Aboutus/>
        <Skill/>
        <Services/>
        <Projects/>
        <Contact/>
        <Footer/>
    </div>
  )
}
